import { render, staticRenderFns } from "./RichText.vue?vue&type=template&id=33fd6d08&scoped=true"
import script from "./RichText.vue?vue&type=script&lang=js"
export * from "./RichText.vue?vue&type=script&lang=js"
import "./RichText.vue?vue&type=style&index=0&id=33fd6d08&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fd6d08",
  null
  
)

export default component.exports